import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import { ModalMode, ROLE_READ_ONLY } from '../../../stores/Administrators/AdministratorModalStore';
import EnvStore from '../../../stores/EnvStore';
import PolicyStore from '../../../stores/Policy/PolicyStore';
import FuseReadOnlySwitch from '../../FuseControls/FuseReadOnlySwitch';
import FuseReadOnlyTextfield from '../../FuseControls/FuseReadOnlyTextfield';
import MatchCriteria from '../MatchCriteria';
import PolicyModal from '../PolicyModal';
import PolicyModalHeaderLayout from '../PolicyModalHeaderLayout';
import ConsoleStore from '../../../stores/ConsoleStore';
import { Card } from '../../Fuse';
import { ConsoleBody } from '../../Text/Text';
import FuseConsoleCardFooter from '../../ConsoleFragments/FuseConsoleCardFooter';
import './ExclusionRulesModal.css';

const block = b.lock('ExclusionRulesModal');

class ExclusionRulesModal extends Component {
    static propTypes = {
        policy: PolicyStore.PropType.isRequired,
        env: EnvStore.PropType.isRequired,
        console: ConsoleStore.PropType,
    };


    renderHeader = () => {
        const { env, policy } = this.props;
        const { policyModal } = policy.exclusionRules.policyTable;
        const store = policyModal.header;
        const readOnly = policyModal.mode === ModalMode.VIEW || policyModal.mode === ModalMode.DELETE;

        return <PolicyModalHeaderLayout
            title="Summary"
            readOnly={readOnly}
        >
            <FuseReadOnlyTextfield
                label="Name"
                store={store.name}
                placeholder="Enter Exclusion Rule name"
                error={!store.name.isValid && store.name.isTouched}
                onBlur={store.onNameFieldFocusChange}
                showRequired={!readOnly}
                required={!readOnly}
                qa="entity-name"
            />

            <FuseReadOnlyTextfield
                label="Description"
                store={store.description}
                readOnlyValue={store.description.value && store.description.value.trim() || '—'}
                placeholder="Enter Exclusion Rule description"
                qa="entity-description"
            />

            <FuseReadOnlySwitch
                header="Rule Status"
                tooltip="The status will determine if the Rule is available to live users or not"
                tooltipProps={env.screen.isMobile || readOnly ? { position: 'right' } : {}}
                store={store.status}
                label={store.status.isTrue ? 'Enabled' : 'Disabled'}
                qa="status-switch"
            />
        </PolicyModalHeaderLayout>;
    };

    constructor(props) {
        super(props);
        const { policy, console } = this.props;
        const { policyModal } = policy.exclusionRules.policyTable;
        policyModal.sections.matchCriteria.setFilterChannelsFunc(console.filterIsolationChannelBasedOnLicense);
    }

    render() {
        const { console, policy } = this.props;
        const { policyModal } = policy.exclusionRules.policyTable;
        const { matchCriteria, categories } = policyModal.sections;
        const readOnly = [ModalMode.VIEW, ModalMode.DELETE].indexOf(policyModal.mode) > -1 ||
            console.authority === ROLE_READ_ONLY.value;

        return <PolicyModal
            titleItemName="Exclusion Rule"
            itemName="Exclusion Rule"
            readOnly={console.authority === ROLE_READ_ONLY.value}
            store={policyModal}
        >
            {this.renderHeader()}
            <MatchCriteria
                store={matchCriteria}
                categoriesStore={categories}
                readOnly={policyModal.getValue().isDefault || readOnly}
            />

            <Card title="Action">
                <ConsoleBody className={block('ActionText')}>
                    Exclude - Send matching URLs to open in the user’s native browser
                </ConsoleBody>
                <FuseConsoleCardFooter
                    text={'Applies to all URL requests in Isolation and clicks on rewritten TAP URL Defense links.'}
                />
            </Card>
        </PolicyModal>;
    }
}

export default inject('env', 'snack', 'policy', 'console')(observer(ExclusionRulesModal));
